<template>
  <div :id="title" class="container">
    <div>
      <div class="articles-grid">
        <div class="articles">
          <div class="grid-title">
            <div>
              <h1 v-if="articlesArea" class="title">
                {{ title | capitalize }}
              </h1>
              <h1 v-else class="title">{{ title | capitalize }}</h1>
            </div>
            <div>
              <span class="search">
                <input
                  type="text"
                  placeholder=" Search for movies or tv shows"
                  class="search--input"
                  v-model="search"
                  @keyup.enter="getArticles()"
                />
                <font-awesome-icon class="search--icon" icon="search" />
                <font-awesome-icon
                  v-show="search"
                  class="search--icon-right"
                  icon="times"
                  @click="resetCriteria()"
                />
              </span>
              <div v-show="articles == '' && alert">
                <span v-if="alert">
                  No result deteced.
                  <span class="tryit" @click="toggleArticles"
                    >Try in Full Articles and Reviews?</span
                  ></span
                >
              </div>
            </div>
          </div>

          <div class="spinner" v-show="loading">
            <div class="loading"></div>
          </div>
          <div v-show="articles == '' && no_result != ''">
            <ith-no-results :text="no_result" />
          </div>
          <template v-for="item in articles">
            <div class="article--item" :key="item.id">
              <figure class="article-img">
                <img
                  class="image"
                  :src="item.imageUrl"
                  :alt="item.title"
                  @click="goToArticle(item)"
                />
              </figure>
              <div class="article--detalle">
                <div>
                  <div class="article--autor no-visible">{{ item.author }}</div>
                  <div class="article--date no-visible">
                    {{ item.date | date_articles }}
                  </div>
                  <div v-if="typeArticle == 'getReviews'" class="rating--title">
                    <div class="text-thin text-center">User Rating</div>
                    <div class="text-center">
                      <span class="rating" v-if="item.show.rating">
                        {{ item.show.rating }}
                        <font-awesome-icon
                          class="form--icon"
                          color="#F3C033"
                          icon="star"
                        />
                      </span>
                      <span class="rating" v-else> N/A </span>
                    </div>
                  </div>
                </div>
                <span
                  :class="{ articleTitleWithRating: title === 'reviews' }"
                  class="article--title"
                >
                  {{ item.title }}
                </span>
                <span class="only-sm article--date">
                  {{ item.date | date_articles }}
                </span>
                <span class="article--description">
                  <p class="no-visible">
                    {{ item.description | truncate_450 }}
                  </p>
                  <p class="only-sm">{{ item.description | truncate_100 }}</p>
                </span>
                <a
                  style="text-decoration: none"
                  :href="`/${title}/${item.id}/${item.slug}`"
                  class="article--see-more"
                >
                  <span>
                    <span class="article--icon"
                      ><font-awesome-icon
                        class="form--icon"
                        icon="plus" /></span
                    >Read The Full Article
                  </span>
                </a>
              </div>
            </div>
          </template>
          <ith-pagination-bullets
            :items="totalPages"
            :pagination="params.page"
            :k="title"
          />
        </div>
        <div class="asside">
          <ith-table-o-t-t-platforms />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    params: {
      page: 0,
      criteria: "",
    },
    // key: this.title,
    articles: [],
    reviews: [],
    totalPages: 0,
    validate: 0,
    search: "",
    no_result: "",
    loading: false,
    alert: false,
    title: "articles",
    banner: null,
  }),
  computed: mapState([
    "pageArticles",
    "pageReviews",
    "articlesArea",
    "typeArticle",
  ]),

  watch: {
    articlesArea() {
      this.typeArticle == "getReviews"
        ? (this.title = "reviews")
        : (this.title = "articles");

      this.params.page = 0;
      this.getArticles();
    },
    pageArticles() {
      if (this.articlesArea === false) {
        this.params.page = this.pageArticles;
        this.getArticles();
      }
    },
    pageReviews() {
      if (this.articlesArea === true) {
        this.params.page = this.pageReviews;
        this.getArticles();
      }
    },
  },
  created() {
    this.getArticles();
  },
  methods: {
    resetCriteria() {
      this.search = "";
      this.getArticles();
    },
    toggleArticles() {
      this.$store.commit("TOGGLE_ARTICLESAREA");
      this.$store.commit("TOGGLE_TYPEARTICLES");
    },

    goToArticle(item) {
      // this.$router.push(`/articles/${item.id}/${item.slug}`);
      window.location.href = `/${this.title}/${item.id}/${item.slug}`;
    },
    getArticles() {
      this.alert = false;
      this.loading = true;
      this.articles = [];

      this.params.criteria = this.search;
      this.$Parse.Cloud.run(this.typeArticle, this.params)
        .then((res) => {
          if (res.items == "") {
            this.validate++;
          } else {
            this.validate = 0;
            this.articles = res.items.map(function (obj) {
              const searchRegExp = /\s/g;
              const replaceWith = "-";
              obj.slug = obj.title.replace(searchRegExp, replaceWith);
              return obj;
            });
          }
          this.totalPages = res.totalPages;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;

          if (this.validate == 1) {
            {
              this.alert = true;
            }
          } else if (this.validate == 2) {
            this.validate = 0;
            this.no_result = "Please try again";
          }
        });
    },
  },
};
</script>

<style scoped>
.title {
  margin-left: 15px;
  font-size: 35px;
}
.articles-grid {
  display: grid;
  grid-template-columns: 70% 27%;
  column-gap: 3%;
  margin-top: 50px;
}
.articles {
  display: grid;
  grid-template-columns: 100%; /*100%*/
  row-gap: 50px;
}
.article--item {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: 420px;
  border-radius: 15px;
  background-color: white;
  color: #283441;
  padding: 0px;
  justify-content: stretch;
  column-gap: 0px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.article-img {
  margin: 0px;
  padding: 0px;
}

.article--autor,
.article--title,
.article--description,
.article--see-more,
.rrss {
  margin-top: 10px;
}

.image {
  border-radius: 15px 0px 0px 15px;
  width: 100%;
  /* width: 468px; */
  height: 100%;
  /* object-fit: cover; */
  object-fit: contain;
}

.article--detalle {
  display: grid;
  grid-template-rows: 12% 8% 45% 7% 15%;
  row-gap: 3%;
  align-items: space-between;
  justify-items: stretch;
  padding-left: 20px;
  padding-right: 15px;
}
.article--autor {
  margin-top: 10px;
  color: #283441;
  font-weight: 600;
  color: #284367;
}
.article--date {
  font-size: 0.9em;
  color: #738092;
}
.article--title {
  margin-top: 2%;
  font-weight: 600;
  color: #284367;
}
.rating--title {
  font-weight: 600;
  color: #284367;
  text-align: right;
}
.article--description > p {
  margin-top: 1%;
  font-size: 0.8em;
  line-height: 20px;
  font-weight: 400;
  overflow-y: hidden;
}
.article--see-more {
  font-size: 0.8em;
  font-weight: 800;
  color: #284367;
}

.article--icon {
  color: #94c659;
  font-weight: 800;
  font-size: 1em;
  margin-right: 7px;
}

.rrss {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.rrss--icon {
  height: 15px;
  width: 15px;
  background-color: #94c659;
  color: white;
  border: 0px;
  border-radius: 6px;
  padding: 3px 5px 7px 5px;
  margin: 0px 5px 5px 0px;
}
.rrss--count {
  font-weight: 600;
  margin-right: 15px;
}
.text-thin {
  font-size: 0.7em;
}
.only-sm {
  display: none;
}
.tryit {
  color: #94c659;
  font-weight: 600;
  cursor: pointer;
}
@media (min-width: 1400px) {
  .article--autor {
    margin-top: 5%;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .article--autor {
    margin-top: 5%;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .article--autor {
    margin-top: 5%;
  }
  .article--item {
    grid-template-rows: 470px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .article--autor {
    margin-top: 5%;
  }
  .articles-grid {
    grid-template-columns: 100%;
    justify-content: space-between;
    row-gap: 50px;
    column-gap: 60px;
    margin-left: 3%;
    margin-right: 3%;
  }
  .asside {
    justify-self: center;
  }
  .content {
    width: 200%;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .articles-grid {
    grid-template-columns: 100%;
    column-gap: 60px;
    margin-left: 3%;
    margin-right: 3%;
  }
  .article--item {
    grid-template-columns: 30% 68%;
    grid-template-rows: 360px;
  }
  .articles {
    margin-bottom: 60px;
  }
  .article-img,
  .image {
    border-radius: 15px 0px 0px 15px;
    object-fit: cover;
    height: 360px;
  }
  .article--detalle {
    grid-template-rows: 12% 8% 60% 7% 15%;
    row-gap: 2px;
    border-radius: 0px 0px 15px 15px;
  }
}

@media (max-width: 600px) {
  .articles-grid {
    padding-left: 10px;
    column-gap: 60px;
    grid-template-columns: 100%;
  }
  .articles {
    grid-template-columns: calc(100% - 10px);
    grid-template-rows: 150px;
    margin-bottom: 60px;
  }
  .article {
    grid-template-rows: 350px 800px;
    margin-bottom: 60px;
  }
  .article--item {
    grid-template-columns: 30% 68%;
    grid-template-rows: 160px;
  }
  .article-img,
  .image {
    border-radius: 15px 0px 0px 15px;
    object-fit: cover;
    height: 160px;
  }

  .article--detalle {
    grid-template-rows: 0px 23px 15px 80px;
    row-gap: 2px;
    border-radius: 0px 0px 15px 15px;
  }

  .article--data {
    margin: 0;
  }
  .articleTitleWithRating {
    width: calc(100% - 90px);
  }
  .article--title {
    white-space: nowrap;
    overflow-y: hidden;
    text-overflow: ellipsis;
  }
  .article--description {
    white-space: wrap;
    overflow-y: hidden;
    text-overflow: ellipsis;
  }
  .no-visible {
    display: none;
  }
  .only-sm {
    display: inline;
  }
  .rating--title {
    margin-top: 8px;
  }
}

/* Styles for searchbar */
.grid-title {
  display: grid;
  grid-template-columns: 20% 80%;
  align-items: center;
  max-height: 50px;
}
.search {
  position: relative;
}
.search--input {
  width: 100%;
  margin: 0;
  background-color: #596678;
  padding: 15px 7% 15px 40px;
  border-radius: 10px;
  border: 0px;
  box-sizing: border-box;
}
.search--input::placeholder {
  padding-left: 0%;
}

.search--icon {
  color: rgba(255, 255, 255, 0.56);
  position: absolute;
  left: 15px;
  top: 3px;
  z-index: 1000;
}
.search--icon-right {
  color: rgba(255, 255, 255, 0.56);
  position: absolute;
  right: 5%;
  top: 3px;
  z-index: 1000;
  padding-left: 20px;
  cursor: pointer;
}

.spinner {
  display: flex;
  justify-content: center;
}
.loading {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .search--icon {
    left: 15px;
  }
  .grid-title {
    grid-template-columns: 29% 71%;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .search--icon {
    left: 12px;
  }
  .grid-title {
    grid-template-columns: 30% 70%;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .search--icon {
    left: 10px;
  }
  .search--input {
    padding-left: 30px;
  }
  .grid-title {
    grid-template-columns: 100%;
    max-height: 120px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .search--icon {
    left: 8x;
  }
  .search--input {
    padding-left: 32px;
  }
  .grid-title {
    grid-template-columns: 100%;
    max-height: 120px;
  }
}

@media (max-width: 600px) {
  .grid-title {
    grid-template-columns: 100%;
    max-height: 120px;
  }
  .search--icon {
    left: 15px;
  }
  .search--input {
    padding-left: 32px;
  }
}
input {
  color: rgba(255, 255, 255, 0.86);
}

input::placeholder {
  color: rgba(255, 255, 255, 0.56);
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
